import * as React from 'react';
import type { SVGProps } from 'react';

const IconTITV = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 128" {...props}>
      <path
        d="M47.742 15.293h-.699V.515H89.69v14.778H76.774c-.74 0-.743 0-.743.735V45.81c-.262-.12-.43-.182-.585-.27-4.739-2.724-9.473-5.455-14.217-8.168-.4-.228-.525-.491-.523-.935.014-6.76.01-13.522.008-20.28 0-.965.076-.858-.84-.86-4.043-.004-8.086 0-12.132 0v-.004Zm-.699 31.976V62H89.69V47.27H47.043ZM1.009 15.294h-.7V.515h42.648v14.779H30.04c-.741 0-.743 0-.743.734V62H13.972s.01-39.084.008-45.843c0-.965.076-.857-.839-.86-4.044-.003-8.087 0-12.132 0v-.003ZM1.009 80.865h-.7V66.086h42.648v14.779H30.04c-.741 0-.743 0-.743.734v45.972H13.972s.01-39.084.008-45.843c0-.964.076-.857-.839-.86-4.044-.003-8.087 0-12.132 0v-.003ZM74.122 66.086 68.36 98.77l-5.763-32.683H47.043c1.616 9.153 10.833 61.483 10.833 61.483h20.967s9.217-52.33 10.833-61.483H74.122Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconTITV;
